import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui';
import { CalendarDays, BookOpen, Users, Headphones, MessageCircle, GraduationCap, Target, Sparkles, UsersRound, Gem } from 'lucide-react';
const includedItems = [{
  icon: CalendarDays,
  title: '7 module online, live',
  sub: 'câte un weekend pe lună, 7 luni'
}, {
  icon: BookOpen,
  title: 'Manual dedicat pentru fiecare modul',
  sub: 'tehnici, exerciții, concepte esențiale'
}, {
  icon: Users,
  title: '6 sesiuni online între module',
  sub: 'câte 3 ore, pentru clarificări și practică'
}, {
  icon: Headphones,
  title: '7 meditații audio ghidate',
  sub: 'cele mai importante exerciții NLP'
}, {
  icon: MessageCircle,
  title: 'Comunitate de suport pe tot parcursul programului',
  sub: ''
}, {
  icon: GraduationCap,
  title: 'Certificare NLP națională și internațională',
  sub: ''
}];
const bonuses = [{
  icon: Target,
  title: 'Sesiune individuală cu Marius Cernea',
  sub: '60 de minute focusate pe situația ta'
}, {
  icon: Sparkles,
  title: 'Inner Blueprint — 5 meditații NLP ghidate',
  sub: 'creativitate, misiune, încredere, obiective, convingeri limitative'
}, {
  icon: UsersRound,
  title: 'Sesiune de mentorat de grup, live',
  sub: 'aprofundare a conceptelor avansate'
}];
export const PricingFull = () => {
  return <section id="pricing" className="py-24 bg-navy relative overflow-hidden" data-id="element-376">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-purple/10 blur-[120px] pointer-events-none z-0" data-id="element-377" />
      <div className="container mx-auto px-6 relative z-10" data-id="element-378">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-12" data-id="element-379">
          <p className="font-display text-gold text-base font-semibold tracking-widest uppercase mb-4" data-id="element-380">
            Alege pachetul potrivit
          </p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-381">
            Alege formatul potrivit pentru tine
          </h2>
          <p className="font-sans text-textSub text-lg leading-relaxed" data-id="element-382">
            Același program complet, indiferent de varianta aleasă. Diferența
            este doar în modul de plată și în resursele suplimentare incluse.
          </p>
        </motion.div>
        {/* Two cards side by side */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-383">
          {/* RATE - Plată în rate */}
          <div className="bg-navy-card border-2 border-gold/40 flex flex-col" data-id="element-384">
            <div className="p-8 md:p-10" data-id="element-385">
              <h3 className="font-serif text-3xl font-bold text-white mb-1" data-id="element-386">
                Plată în rate
              </h3>
              <p className="font-sans text-textSub text-base mb-6" data-id="element-387">
                Flexibilitate lunară
              </p>
              <div className="flex items-end gap-2 mb-1" data-id="element-388">
                <span className="font-serif text-5xl md:text-6xl font-bold text-white leading-none" data-id="element-389">
                  750 RON
                </span>
                <span className="font-sans text-white text-xl mb-1" data-id="element-390">
                  / lună
                </span>
              </div>
              <p className="font-sans text-textSub text-base mb-8" data-id="element-391">
                7 rate · total 5.250 RON
              </p>
              <div className="w-full h-px bg-white/10 mb-6" data-id="element-392" />
              <p className="font-display text-xs font-bold tracking-widest uppercase text-textSub mb-6" data-id="element-393">
                Ce include programul
              </p>
              <ul className="space-y-5" data-id="element-394">
                {includedItems.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-395">
                    <item.icon className="w-5 h-5 text-gold shrink-0 mt-0.5 stroke-[1.5]" data-id="element-396" />
                    <div data-id="element-397">
                      <span className="block font-sans text-white text-lg font-semibold leading-snug" data-id="element-398">
                        {item.title}
                      </span>
                      {item.sub && <span className="block font-sans text-textSub text-sm mt-0.5" data-id="element-399">
                          {item.sub}
                        </span>}
                    </div>
                  </li>)}
              </ul>
            </div>
            <div className="p-8 md:p-10 pt-0 mt-auto" data-id="element-400">
              <a href="https://link.apisystem.tech/widget/form/ZUjFtHGgCAZU8EKnYStZ" className="inline-flex items-center justify-center w-full text-base py-5 px-8 font-display font-semibold tracking-wide uppercase border border-gold text-gold hover:bg-gold hover:text-navy-dark transition-all duration-300" data-id="element-401">
                Alege plata în rate · 750 RON/lună
              </a>
            </div>
          </div>
          {/* INTEGRAL - Plată integrală */}
          <div className="bg-navy-card border-2 border-gold flex flex-col relative shadow-2xl shadow-gold/10" data-id="element-402">
            <div className="p-8 md:p-10" data-id="element-403">
              <div className="inline-flex items-center gap-2 bg-gold px-3 py-1 mb-5 rounded" data-id="element-404">
                <span className="font-display text-[10px] font-bold tracking-widest uppercase text-navy-dark" data-id="element-405">
                  Recomandat
                </span>
              </div>
              <h3 className="font-serif text-3xl font-bold text-white mb-1" data-id="element-406">
                Plată integrală
              </h3>
              <p className="font-sans text-textSub text-base mb-6" data-id="element-407">
                Un singur angajament, resurse suplimentare incluse
              </p>
              <div className="flex items-end gap-2 mb-1" data-id="element-408">
                <span className="font-serif text-5xl md:text-6xl font-bold text-gold leading-none" data-id="element-409">
                  4.500 RON
                </span>
              </div>
              <p className="font-sans text-textSub text-base mb-8" data-id="element-410">
                O singură plată · economisești 750 RON față de rate
              </p>
              <div className="w-full h-px bg-gold/20 mb-6" data-id="element-411" />
              <p className="font-display text-xs font-bold tracking-widest uppercase text-textSub mb-6" data-id="element-412">
                Ce include programul
              </p>
              <ul className="space-y-5 mb-8" data-id="element-413">
                {includedItems.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-414">
                    <item.icon className="w-5 h-5 text-gold shrink-0 mt-0.5 stroke-[1.5]" data-id="element-415" />
                    <div data-id="element-416">
                      <span className="block font-sans text-white text-lg font-semibold leading-snug" data-id="element-417">
                        {item.title}
                      </span>
                      {item.sub && <span className="block font-sans text-textSub text-sm mt-0.5" data-id="element-418">
                          {item.sub}
                        </span>}
                    </div>
                  </li>)}
              </ul>
              <p className="font-display text-xs font-bold tracking-widest uppercase text-gold mb-6" data-id="element-419">
                Inclus la plata integrală
              </p>
              <ul className="space-y-5" data-id="element-420">
                {bonuses.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-421">
                    <item.icon className="w-5 h-5 text-gold shrink-0 mt-0.5 stroke-[1.5]" data-id="element-422" />
                    <div data-id="element-423">
                      <span className="block font-sans text-white text-lg font-semibold leading-snug" data-id="element-424">
                        {item.title}
                      </span>
                      {item.sub && <span className="block font-sans text-textSub text-sm mt-0.5" data-id="element-425">
                          {item.sub}
                        </span>}
                    </div>
                  </li>)}
              </ul>
            </div>
            <div className="p-8 md:p-10 pt-0 mt-auto" data-id="element-426">
              <a href="https://link.apisystem.tech/widget/form/ZUjFtHGgCAZU8EKnYStZ" className="inline-flex items-center justify-center w-full text-base py-5 px-8 font-display font-semibold tracking-wide uppercase bg-gold text-navy-dark hover:bg-white hover:text-navy-dark transition-all duration-300" data-id="element-427">
                Rezervă-mi locul acum · 4.500 RON
              </a>
            </div>
          </div>
        </motion.div>
        {/* Referral note */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="mt-10 max-w-6xl mx-auto" data-id="element-428">
          <div className="bg-navy-card border border-gold/20 p-8 flex items-start gap-5" data-id="element-429">
            <Gem className="w-6 h-6 text-gold shrink-0 mt-0.5 stroke-[1.5]" data-id="element-430" />
            <div data-id="element-431">
              <h4 className="font-serif text-xl font-bold text-white mb-2" data-id="element-432">
                Cunoști pe cineva interesat de NLP?
              </h4>
              <p className="font-sans text-textSub text-base leading-relaxed" data-id="element-433">
                Dacă recomanzi o persoană care se înscrie în program, atât tu
                cât și persoana recomandată primiți câte o sesiune de coaching
                pe obiective, cadou — înainte de începerea programului. Nu
                există un cod sau un formular. Îi trimiți un mesaj, ea se
                înscrie și menționează că ai recomandat-o. Atât.
              </p>
            </div>
          </div>
        </motion.div>
        {/* Urgency note */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-10 text-center" data-id="element-434">
          <div className="inline-flex items-center gap-3 bg-red-500/10 border border-red-500/20 px-6 py-3 rounded-full" data-id="element-435">
            <span className="relative flex h-3 w-3" data-id="element-436">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-437"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" data-id="element-438"></span>
            </span>
            <p className="font-sans text-white text-xl" data-id="element-439">
              <strong className="text-red-400" data-id="element-440">Locurile sunt limitate.</strong>{' '}
              Primul modul începe pe 13-14 Iunie 2026.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};